import './header.scss';

import enquire from 'enquire.js';
import { Responsive } from '../utils';

const COMPONENT_NAME = 'primary-header';

const BEM = {
  BLOCK: COMPONENT_NAME,
  BURGER_MOBILE_MENU_OPEN: 'custom-navbar-toggler',
  BURGER_MOBILE_MENU_CLOSE: 'close-menu',
  FIRST_SON_CLICK_IMG: 'btn-first-son-img',
  SECOND_SON_CLICK_IMG: 'btn-second-son-img',
};

/**
 * version    1.0
 * class      <type> (Header)
 * classdesc  Component that manage the page header
 */
export class Header {
  constructor() {
    this._findUIElements();
    this._bindEvents();
    this._fixEuroLineBreak();
  }

  // private methods

  _findUIElements() {
    this._els = {
      burgerMobileMenuOpen: $(`.${BEM.BURGER_MOBILE_MENU_OPEN}`),
      burgerMobileMenuClose: $(`.${BEM.BURGER_MOBILE_MENU_CLOSE}`),
      firstSonBtnImg: $(`.${BEM.FIRST_SON_CLICK_IMG}`),
      secondSonBtnImg: $(`.${BEM.SECOND_SON_CLICK_IMG}`),
    };
  }

  _bindEvents() {
    const self = this;
    enquire.register(`${Responsive.getBreakpointMaxMediaQuery('md')}`, () => {
      self._openMobileMenu();
      self._closeMobileMenu();
    });
    this._handleDropdownExpansion();
  }

  _openMobileMenu() {
    this._els.burgerMobileMenuOpen.on('click', () => {
      $('body').addClass('opened-menu-mobile');
    });
  }

  _closeMobileMenu() {
    this._els.burgerMobileMenuClose.on('click', () => {
      $('body').removeClass('opened-menu-mobile');
    });
  }

  _handleDropdownExpansion() {
    const navWrapper = document.querySelector('.it-header-navbar-wrapper');
    if (!navWrapper) return;

    const updateBeforeBottom = () => {
      const openDropdown = navWrapper.querySelector('.dropdown-menu.show');
      if (openDropdown) {
        const wrapperRect = navWrapper.getBoundingClientRect();
        const dropdownRect = openDropdown.getBoundingClientRect();
        const extendBelow = Math.max(0, dropdownRect.bottom - wrapperRect.bottom);
        navWrapper.style.setProperty('--header-before-extra-bottom', `-${extendBelow}px`);
      }
    };

    document.addEventListener('shown.bs.dropdown', (event) => {
      const navItem = event.target.closest('.nav-item');
      if (!navItem) return;
      const dropdown = navItem.querySelector('.dropdown-menu');
      if (dropdown) {
        const wrapperRect = navWrapper.getBoundingClientRect();
        const dropdownRect = dropdown.getBoundingClientRect();
        const extendBelow = Math.max(0, dropdownRect.bottom - wrapperRect.bottom);
        navWrapper.style.setProperty('--header-before-extra-bottom', `-${extendBelow}px`);
      }
    });

    document.addEventListener('hidden.bs.dropdown', () => {
      const openDropdown = navWrapper.querySelector('.dropdown-menu.show');
      if (!openDropdown) {
        navWrapper.style.removeProperty('--header-before-extra-bottom');
      }
    });

    window.addEventListener('resize', updateBeforeBottom);
  }

  // Sostituisce lo spazio prima di € con un non-breaking space per evitare che il simbolo vada a capo da solo
  _fixEuroLineBreak() {
    document
      .querySelectorAll('.dropdown-menu .internal-box.internal-box--card p')
      .forEach((el) => {
        const p = el;
        p.innerHTML = p.innerHTML.replace(/\s€/g, '\u00A0€');
      });
  }
}
